
import { getPublicData } from "../../../../../../services/publicPegasApi/MakePublicOrder";
import { getSubdomain } from "../../../../../../services/helpers";

// ✅ تحويل صورة إلى Base64 (أفضل حل للطباعة)
const toBase64 = async (url) => {
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) throw new Error("Failed to fetch image for base64");
  const blob = await res.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onloadend = () => resolve(reader.result); // data:image/...;base64,...
    reader.readAsDataURL(blob);
  });
};

export default async function CustomerInvoiceTemplate(orderDetails = {}, invoiceData = {}, orderId) {
  let publicData = {};
  try {
    publicData = await getPublicData();
    console.log("📞 بيانات الشركة المسترجعة:", publicData);
  } catch (err) {
    console.error("❌ فشل في جلب البيانات العامة:", err);
  }

  // ✅ رابط كامل + ترميز المسارات (بدون حذف المسافات)
  const subdomain = getSubdomain();
  const base = `https://${subdomain}.restocash.app/`;

  const logoPath = (publicData?.logo || "").trim();
  const logoUrl = logoPath ? new URL(encodeURI(logoPath), base).toString() : "";
  console.log("🖼️ رابط اللوجو النهائي:", logoUrl);

  // ✅ Base64 للّوجو (الأفضل للطباعة)
  let logoBase64 = "";
  if (logoUrl) {
    try {
      logoBase64 = await toBase64(logoUrl);
      console.log("✅ Logo Base64 جاهز للطباعة");
    } catch (e) {
      console.warn("⚠️ فشل تحويل اللوجو Base64، هنستخدم URL عادي", e);
    }
  }

  const items = orderDetails.items || [];

const subtotal = items.reduce((acc, item) => {
  const qty = Number(item.quantity) || 0;
  const unit =
    Number(item.price) ||
    Number(item.unit_price) ||
    (Number(item.total) && qty ? Number(item.total) / qty : 0) ||
    0;

  return acc + unit * qty;
}, 0);

const isPercent = (v) => Number(v) === 1 || v === true || v === "1";

const deliveryIsPct = isPercent(invoiceData.delivery_is_percentage);
const taxIsPct      = isPercent(invoiceData.tax_is_percentage);
const discountIsPct = isPercent(invoiceData.discount_is_percentage);

const deliveryValue = Number(invoiceData.delivery) || 0;
const taxValue      = Number(invoiceData.tax) || 0;
const discountValue = Number(invoiceData.discount) || 0;

const deliveryRatio = Number(invoiceData.delivery_ratio) || 0;
const taxRatio      = Number(invoiceData.tax_ratio) || 0;
const discountRatio = Number(invoiceData.discount_ratio) || 0;

// ✅ لو نسبة استخدم *_ratio مش *_value
const delivery = deliveryIsPct ? (subtotal * deliveryRatio) / 100 : deliveryValue;
const tax      = taxIsPct      ? (subtotal * taxRatio) / 100      : taxValue;
const discount = discountIsPct ? (subtotal * discountRatio) / 100 : discountValue;

const total = subtotal + delivery + tax - discount;



  const footerText = (() => {
    const baseTxt = (invoiceData.footer_text || "").trim();
    const note = (publicData?.invoice_note_printer || "").trim();
    const pieces = [];
    if (baseTxt) pieces.push(baseTxt);
    if (note) pieces.push(note);
    return pieces.join("<br/>");
  })();

  const address = publicData?.address || "";
  const phone = publicData?.phone || "";

  const orderPrintNumber = invoiceData?.order_print_number || 1;

  // ✅ مصدر الصورة: Base64 لو متاح، وإلا URL
  const logoSrc = logoBase64 || logoUrl;

  return `
    <!DOCTYPE html>
    <html dir="rtl">
    <head>
      <meta charset="UTF-8" />
      ${logoUrl ? `<link rel="preload" as="image" href="${logoUrl}" />` : ""}

      <style>
        @page { size: 80mm auto; margin: 0; }
        html, body {
          height: 100%;
          margin: 0;
          padding: 0;
          display: flex;
          justify-content: center;
          background: #fff;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .receipt {
          font-family: 'Cairo', sans-serif;
          width: 80mm;
          padding: 10px;
          margin: 0 auto;
          font-size: 14px;
          font-weight: bold;
          color: #000;
          direction: rtl;
          text-align: right;
          box-sizing: border-box;
          line-height: 1.6;
          text-shadow: 0.3px 0.3px 0px rgba(0, 0, 0, 0.5);
        }
        h2, h3 { margin: 6px 0; text-align: center; font-weight: 900; text-shadow: 0.5px 0.5px 0px rgba(0, 0, 0, 0.6); line-height: 1.5; }
        hr { border: none; border-top: 1.5px dashed #000; margin: 8px 0; }
        table { width: 100%; border-collapse: collapse; }
        th, td { padding: 5px 0; text-align: right; font-weight: bold; line-height: 1.5; }
        th { border-bottom: 1.5px dashed #000; text-shadow: 0.3px 0.3px 0px rgba(0, 0, 0, 0.5); }
        .footer { text-align: center; margin-top: 12px; font-size: 12px; font-weight: bold; line-height: 1.6; }
        .logo {
          width: 120px;
          height: auto;
          object-fit: contain;
          display: block;
          margin: 0 auto 20px;
        }
      </style>

      <script>
        // ✅ انتظر تحميل الصور والخطوط قبل الطباعة (مفيد لكل الطرق)
        async function waitForAssets() {
          try {
            if (document.fonts && document.fonts.ready) {
              await document.fonts.ready;
            }
          } catch (e) {}

          const imgs = Array.from(document.images || []);
          await Promise.all(imgs.map(img => {
            if (img.complete) return Promise.resolve();
            return new Promise(resolve => {
              img.onload = () => resolve();
              img.onerror = () => resolve(); // نخلي الطباعة تكمل حتى لو صورة فشلت
            });
          }));

          // frame لتثبيت الـ layout قبل print
          await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
        }

        window.__waitForAssets = waitForAssets;
      </script>
    </head>

    <body>
      <div class="receipt">
        ${logoSrc ? `<img src="${logoSrc}" class="logo" alt="Logo" onerror="this.style.display='none'" />` : ""}

        <h2>${invoiceData.header_text || publicData?.name || "تطبيق رستو كاش"}</h2>
        <h3> رقم #${orderDetails.general_increment || orderId || "-"}</h3>

        <p><strong>عدد مرات الطباعة:</strong> ${orderPrintNumber}</p>
        <p><strong>نوع الطلب:</strong> ${orderDetails.order_type || "-"}</p>

        <hr />
        <p>العميل: ${orderDetails.customer?.name || "بدون اسم"}</p>
        ${orderDetails.customer?.phone1 ? `<p>رقم 1: ${orderDetails.customer.phone1}</p>` : ""}
        ${orderDetails.customer?.phone2 ? `<p>رقم 2: ${orderDetails.customer.phone2}</p>` : ""}
        ${orderDetails.customer?.phone3 ? `<p>رقم 3: ${orderDetails.customer.phone3}</p>` : ""}
        ${orderDetails.customer?.address1 ? `<p>العنوان 1: ${orderDetails.customer.address1}</p>` : ""}
        ${orderDetails.customer?.address2 ? `<p>العنوان 2: ${orderDetails.customer.address2}</p>` : ""}
        ${orderDetails.customer?.address3 ? `<p>العنوان 3: ${orderDetails.customer.address3}</p>` : ""}
        <p>الطيار : ${orderDetails.delivery?.name || "غير محددة"}</p>

        <hr />
        <table>
          <thead>
            <tr>
              <th>الصنف</th>
              <th>السعر</th>
              <th>الكمية</th>
              <th>الإجمالي</th>
            </tr>
          </thead>
          <tbody>
            ${items.map((item) => {
              const price = parseFloat(item.price || item.unit_price || item.total / item.quantity || 0);
              return `
                <tr>
                  <td>${item.product_name || "-"}</td>
                  <td>${price.toFixed(2)} ج</td>
                  <td>${item.quantity}</td>
                  <td>${parseFloat(item.total || 0).toFixed(2)} ج</td>
                </tr>
              `;
            }).join("")}
          </tbody>
        </table>

        <hr />
        <p>الإجمالي الفرعي: ${subtotal.toFixed(2)} ج</p>
        <p>رسوم التوصيل: ${delivery.toFixed(2)} ج</p>
        <p>الضريبة: ${tax.toFixed(2)} ج</p>
        <p>الخصم: ${discount.toFixed(2)} ج</p>
        <hr />
        <h3>الإجمالي الكلي: ${total.toFixed(2)} ج</h3>
        <hr />

        <div class="footer">
          ${footerText ? `<p>${footerText}</p>` : `<p>شكرًا لزيارتكم ❤️</p>`}
          ${address ? `<p>📍 العنوان: ${address}</p>` : ""}
          ${phone ? `<p>📞 الهاتف: ${phone}</p>` : ""}
          <p>تم بواسطة نظام ريستو كاش</p>
        </div>
      </div>
    </body>
    </html>
  `;
}
